import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import "./cycle-toggle.script";
export function RuiCycleToggleItem({
  id,
  children,
  class: className,
  disabled,
  selected,
  ...props
}) {
  return /* @__PURE__ */jsx("span", {
    ...props,
    class: cx("rui-cycle-toggle__item", className),
    "data-cycle-value": id,
    hidden: selected === void 0 ? void 0 : !selected,
    "aria-disabled": disabled ? "true" : void 0,
    children
  });
}
export function RuiCycleToggleButton({
  children,
  variant = "filled",
  size = "md",
  disabled,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("button", {
    ...props,
    type: "button",
    class: cx("rui-button", "rui-cycle-toggle__button", `rui-button--${variant}`, `rui-button--${size}`, className),
    disabled,
    "data-cycle-toggle-button": true,
    children
  });
}
export function RuiCycleToggle({
  children,
  variant,
  size,
  disabled,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-cycle-toggle", {
    ...props,
    variant,
    size,
    disabled,
    children: /* @__PURE__ */jsx(RuiCycleToggleButton, {
      variant,
      size,
      disabled,
      children
    })
  });
}